var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_954_14070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.689 14.1604L20.189 9.83024C20.4543 9.37087 20.5261 8.82496 20.3888 8.3126C20.2516 7.80024 19.9164 7.36341 19.457 7.09819C18.9976 6.83297 18.4517 6.7611 17.9394 6.89839C17.427 7.03568 16.9902 7.37087 16.7249 7.83024M14.7249 11.2943L17.7249 6.09819C17.9902 5.63882 18.062 5.09291 17.9247 4.58055C17.7875 4.06819 17.4523 3.63136 16.9929 3.36614C16.5335 3.10092 15.9876 3.02905 15.4753 3.16634C14.9629 3.30363 14.5261 3.63882 14.2608 4.09819L13.2608 5.83024M13.2608 5.83024L11.0108 9.72736M13.2608 5.83024C13.5261 5.37087 13.5979 4.82496 13.4606 4.3126C13.3234 3.80024 12.9882 3.36341 12.5288 3.09819C12.0694 2.83297 11.5235 2.7611 11.0112 2.89839C10.4988 3.03568 10.062 3.37087 9.79674 3.83024L5.79674 10.7584M19.189 11.5623C19.4543 11.1029 19.8911 10.7677 20.4035 10.6304C20.9158 10.4932 21.4617 10.565 21.9211 10.8302C22.3805 11.0955 22.7157 11.5323 22.8529 12.0447C22.9902 12.557 22.9184 13.1029 22.6531 13.5623L19.6531 18.7584C18.5923 20.5959 16.8449 21.9367 14.7955 22.4859C12.7461 23.035 10.5624 22.7475 8.72494 21.6866L6.99289 20.6866C4.56802 19.2866 3.52578 17.6919 2.9754 15.6651L1.65771 10.7475C1.55027 10.2454 1.64001 9.72129 1.90834 9.28359C2.17668 8.8459 2.60306 8.52815 3.09921 8.39615C3.59535 8.26415 4.12326 8.328 4.57362 8.57449C5.02399 8.82097 5.36232 9.23121 5.51856 9.72027L6.16277 12.1245",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_954_14070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGk);
export default __webpack_public_path__ + "static/media/gk.5388cbd367c07bf87a5be526932a36a1.svg";
export { ForwardRef as ReactComponent };